import { wrapEndpoint } from '@/plugins/api/openapi/wrap'
import { ApiSchemas } from '..'
import { client } from '../client'
import { useDeviceCodeStore } from '@/store/pinia/device-code'

export type User = ApiSchemas['UserPresenter']

export type Session = ApiSchemas['SessionPresenter']

export default {
  async login(body: ApiSchemas['SignInDto']) {
    const deviceCodeStore = useDeviceCodeStore()
    const deviceCode = deviceCodeStore.getFromMap(body.email)

    const headers = deviceCode ? { 'Bioplanner-Device-Code': deviceCode } : undefined

    return wrapEndpoint(() =>
      client.POST('/auth/sign-in', {
        body,
        headers,
      }),
    )
  },

  async login2FA(body: ApiSchemas['SignInWith2FADto']) {
    return wrapEndpoint(() =>
      client.POST('/auth/sign-in-with-2fa', {
        body,
      }),
    )
  },

  async resend2FACode() {
    return wrapEndpoint(() => client.PATCH('/auth/resend-2fa-code', {}))
  },

  async sendVerificationCode(body: ApiSchemas['SendVerificationCodeDto']) {
    await wrapEndpoint(() =>
      client.POST('/auth/send-verification-code', {
        body,
      }),
    )
  },

  async loginByVerificationCode(body: ApiSchemas['SignInWithCodeDto']) {
    return wrapEndpoint(() =>
      client.POST('/auth/sign-in-with-code', {
        body,
      }),
    )
  },

  async logout() {
    await wrapEndpoint(() => client.PATCH('/auth/sign-out'))
  },

  async logoutSession(sessionId: string) {
    await wrapEndpoint(() =>
      client.PATCH('/auth/sign-out/{sessionId}', {
        params: {
          path: {
            sessionId,
          },
        },
      }),
    )
  },

  async refresh() {
    return wrapEndpoint(() => client.PATCH('/auth/refresh'))
  },

  async createPhysician(body: ApiSchemas['CreatePhysicianDto']) {
    return wrapEndpoint(() =>
      client.POST('/auth/sign-up/physician', {
        body,
      }),
    )
  },

  async sendResetPasswordEmail(body: ApiSchemas['SendResetPasswordCodeDto']) {
    await wrapEndpoint(() =>
      client.POST('/auth/send-reset-password', {
        body,
      }),
    )
  },

  async resetPassword(body: ApiSchemas['ResetPasswordDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/auth/reset-password', {
        body: {
          code: body.code,
          email: body.email,
          password: body.password,
        },
      }),
    )
  },

  async hasPassword(email: string) {
    return wrapEndpoint(() =>
      client.GET('/auth/{email}/has-password', {
        params: {
          path: {
            email,
          },
        },
      }),
    )
  },
  async checkVerificationCode(body: ApiSchemas['CheckVerificationCodeDto']) {
    return wrapEndpoint(() =>
      client.PATCH('/auth/check-verification-code', {
        body,
      }),
    )
  },
  async ping(){
    await wrapEndpoint(() => client.GET('/auth/ping'))
  },
}
